<template>
  <v-card>
    <v-card-title>
      Item - {{ propItem.serialNumber }}

      <div class="flex-grow-1"></div>

      <v-btn icon @click="$emit('editMode')">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row v-if="propItem.Customer">
        <v-col class="text-right font-weight-light">Customer</v-col>
        <v-col class="text-left font-weight-bold">{{ propItem.Customer.name }}</v-col>
      </v-row>
      <v-row v-if="propItem.Location">
        <v-col class="text-right font-weight-light">Location</v-col>
        <v-col class="text-left font-weight-bold">{{ propItem.Location.name }}</v-col>
      </v-row>
      <v-row v-for="(value, key) in propItem" :key="key">
        <v-col class="text-right font-weight-light" v-if="!excludedFields.includes(key)">{{ key }}</v-col>
        <v-col class="text-left font-weight-bold" v-if="!excludedFields.includes(key)">{{ value }}</v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ShowItem',

  props: ['propItem'],

  data: () => ({
    excludedFields: [
      'Customer',
      'CustomerId',
      'Location',
      'LocationId',
      'Logs'
    ]
  })
}
</script>
